import styled from "styled-components";
import { useRef, useState } from "react";
import { modalProps } from "../../../../Component/Interface/Modal";
import { RowView } from "../../../../Component/style/common_style";
import api, { logout as clearSessionAndRedirect } from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";

const WithdrawModal = ({ visible, handleModal }: modalProps) => {
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const closeModal = () => {
    if (!pending.current) { setError(""); handleModal(); }
  };
  const dropUser = async () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      const res = await api.delete(url.Communication_url.dropUser, {});
      if (res.data !== "성공") throw new Error("회원탈퇴 결과를 확인하지 못했습니다.");
      alert("탈퇴 되었습니다.");
      clearSessionAndRedirect();
    } catch (cause: any) {
      const message = cause?.response?.data?.message;
      setError(typeof message === "string" ? message : "회원탈퇴를 완료하지 못했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };
  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={(event) => event.stopPropagation()}>
        <Title>회원탈퇴</Title>
        <ContentDiv>
          <div>회원탈퇴시 계정 정보는 삭제되어 재가입 시 복구가 불가능해요.</div>
          <br />
          <div>정말 탈퇴할까요?</div>
        </ContentDiv>
        {error && <p role="alert">{error}</p>}
        <BtnDiv>
          <CancelBtn as="button" type="button" disabled={busy} onClick={closeModal}>취소하기</CancelBtn>
          <ApplyBtn as="button" type="button" disabled={busy} onClick={dropUser}>{busy ? "처리 중" : "탈퇴하기"}</ApplyBtn>
        </BtnDiv>
      </ModalBox>
    </Container>
  );
};
export default WithdrawModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 22rem;
  margin: auto 0rem;
  background-color: var(--user-surface);
  color: var(--user-text);
  border-radius: 8px;
  overflow: hidden;
  padding: 2rem 1rem 1rem 1rem;
  div.info {
    color: var(--user-text-muted);
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const ContentDiv = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
  color: var(--user-text-muted);
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.div`
  border: 0;
  &:disabled { cursor: wait; opacity: 0.6; }
  border-radius: 8px;
  padding: 18px 30px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const CancelBtn = styled(Btn)`
  margin-right: 5px;
  background-color: var(--user-surface-raised);
  color: var(--user-text-muted);
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
`;
